import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import api from "../../services/api";
import ExactLogo from "../../assets/Exact_logo_red.png";

const SendToExact = ({ bank, setBank }) => {
  const [showModal, setShowModal] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const prevStatus = useRef(bank.status);

  useEffect(() => {
    if (bank.status === "DONE" && prevStatus.current !== "DONE" && bank.files?.length > 0 && bank.source !== "BNP") setShowModal(true);
    prevStatus.current = bank.status;
  }, [bank.status]);

  const handleSend = async () => {
    try {
      setIsSending(true);
      const { ok, data } = await api.post(`/bank/${bank._id}/send-to-exact`);
      if (!ok) throw new Error("Error while sending to Exact");
      toast.success("File sent to Exact");
      setBank(data);
    } catch (error) {
      console.error(error);
      toast.error("Error while sending to Exact");
    } finally {
      setIsSending(false);
      setShowModal(false);
    }
  };

  return (
    <>
      <div className="flex justify-start items-end">
        <button className="btn gray-btn w-full" onClick={() => setShowModal(true)}>
          Send to <img src={ExactLogo} alt="Exact" className="h-5 w-auto ml-1" />
        </button>
      </div>
      <div className="flex justify-start items-end">
        {bank.files_sent_to_exact_at ? (
          <div className="text-sm text-gray-500">
            Sent to Exact at {new Date(bank.files_sent_to_exact_at).toLocaleString()} by {bank.files_sent_to_exact_by}
          </div>
        ) : (
          <div className="text-sm text-gray-500">Not sent to Exact</div>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-2xl w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">
              Are you sure you want to send this file to <img src={ExactLogo} alt="Exact" className="h-5 w-auto ml-1" /> ?{" "}
            </h3>
            {bank.files?.length > 0 && (
              <div className="mb-4 space-y-4">
                {bank.files.map((file, index) => (
                  <div key={index}>
                    {file.toLowerCase().endsWith(".pdf") ? (
                      <iframe src={file} className="w-full h-96 border rounded" title={`PDF Preview ${index + 1}`} />
                    ) : file.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                      <img src={file} alt={`File Preview ${index + 1}`} className="max-h-96 max-w-full object-contain" />
                    ) : (
                      <p className="text-sm text-gray-500">Preview not available for this file type</p>
                    )}
                  </div>
                ))}
              </div>
            )}

            <div className="flex justify-end gap-3">
              <button className="btn gray-btn" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button disabled={isSending} className="btn blue-btn disabled:opacity-50 disabled:cursor-not-allowed" onClick={handleSend}>
                Send
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SendToExact;
